<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }} <strong>{{ qiJobNumber }}</strong>
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
              <div class="row">
                  <div class="col-xl-3 col-md-6">
                      <div class="form-group mb-3">
                          <label class="label mb-0"><strong>สถานะการดำเนินการ :</strong></label>
                          <span class="form-control-plaintext" v-html="qiStatusName"></span>
                      </div>
                  </div>
                  <div class="col-xl-3 col-md-6">
                      <div class="form-group mb-3">
                          <label class="label mb-0"><strong>วันที่สร้าง :</strong></label>
                          <span class="form-control-plaintext">{{ createdDate }}</span>
                      </div>
                  </div>
                  <div class="col-xl-3 col-md-6">
                      <div class="form-group mb-3">
                          <label class="label mb-0"><strong>วันที่ช่างบันทึกข้อมูลเบิก/คืน :</strong></label>
                          <span class="form-control-plaintext">{{ finishedDate }}</span>
                      </div>
                  </div>
                  <div class="col-xl-3 col-md-6">
                      <div class="form-group mb-3">
                          <label class="label mb-0"><strong>ชื่อช่าง :</strong></label>
                          <span class="form-control-plaintext">{{ createdUserName }}</span>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-xl-3 col-md-6">
                      <div class="form-group mb-3">
                          <label class="label mb-0"><strong>ประเภทใบงาน :</strong></label>
                          <span class="form-control-plaintext" v-html="qiTypeName"></span>
                      </div>
                  </div>
                  <div class="col-xl-3 col-md-6">
                      <label class="label mb-0"><strong>สถานที่ซ่อมอุปกรณ์:</strong></label>
                      <span class="form-control-plaintext">
                          {{ qiAreaPlant ? 'ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด' : 'ซ่อมในตัวแทนจำหน่าย' }}
                      </span>
                  </div>
                  <div v-if="qiTypeCode == 'JOB_QI_TYPE_DRAWBACK'" class="col-xl-3 col-md-6">
                      <div class="form-group mb-3">
                          <label class="label mb-0"><strong>วันที่ยืนยันการตรวจสอบข้อมูล :</strong></label>
                          <span class="form-control-plaintext">{{ confirmedDate }}</span>
                      </div>
                  </div>
                  <div v-if="qiTypeCode == 'JOB_QI_TYPE_DRAWBACK'" class="col-xl-3 col-md-6">
                      <div class="form-group mb-3">
                          <label class="label mb-0"><strong>ผู้ยืนยันการตรวจสอบข้อมูล :</strong></label>
                          <span class="form-control-plaintext">{{ confirmedUserName }}</span>
                      </div>
                  </div>
              </div>

              <div class="kt-section kt-section--first" id="FormDrawback">
                  <div class="kt-section__body">
                      <label class="label mb-0"><strong>ข้อมูลการเบิก/คืน อุปกรณ์เบียร์สด :</strong></label>
                      <span class="form-text mb-3"></span>
                      <div class="row">
                          <div class="col-sm-12 table-responsive">
                              <table class="table table-sm table-striped table-bordered table-checkable">
                                  <thead>
                                      <tr :class="qiSubType === 1 ? 'table-warning' : 'table-info'">
                                          <th class="text-center" width="5%">ลำดับ</th>
                                          <th class="text-center" width="30%">รายการอุปกรณ์</th>
                                          <th class="text-center" width="10%">จำนวน</th>
                                          <th class="text-center" width="10%">ราคา/หน่วย</th>
                                          <th class="text-center" width="10%">มูลค่ารวม</th>
                                          <th class="text-center" width="30%">หมายเหตุ</th>
                                          <th class="text-center" width="5%">คำสั่ง</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for="(item, i) in items" :key="item.qiJobItemId">
                                          <td class="text-center"><span class="form-control form-control-plaintext">{{ i + 1 }}</span></td>
                                          <td>
                                              <select2 class="form-control text-right"
                                                       :select2-options="getMaterialCodeOptions(i)"
                                                       @selectChange="onMaterialCodeChange(i)"
                                                       v-model="item.materialCode"
                                                       :ref="`materialSelect2-${i}`"
                                                       :disabled="!isDisable"></select2>
                                              <span class="form-text text-danger">{{ errors[i] && errors[i].materialCode ? errors[i].materialCode : '' }}</span>
                                          </td>
                                          <td>
                                              <input type="number" v-model.number="item.quantity" :ref="`quantity-${i}`" class="form-control text-right" :disabled="!isDisable" />
                                              <span class="form-text text-danger">{{ errors[i] && errors[i].quantity ? errors[i].quantity : '' }}</span>
                                          </td>
                                          <td>
                                              <input type="number" v-model.number="item.unitPrice" step="0.01" :ref="`unitPrice-${i}`" class="form-control text-right" />
                                              <span class="form-text text-danger">{{ errors[i] && errors[i].unitPrice ? errors[i].unitPrice : '' }}</span>
                                          </td>
                                          <td class="text-right">
                                              <span class="form-control form-control-plaintext">
                                                  {{ (item.quantity * item.unitPrice || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                              </span>
                                          </td>
                                          <td>
                                              <input type="text" v-model="item.remark" class="form-control" :disabled="!isDisable" />
                                          </td>
                                          <td class="text-center">
                                              <span v-if="isDisable">
                                                  <button @click="onRemoveItemClick(i)" type="button" class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon">
                                                      <i class="text-danger la la-trash"></i>
                                                  </button>
                                              </span>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td colspan="2" class="text-right p-3"><strong>รวมจำนวน/มูลค่ารวม</strong></td>
                                          <td class="text-right">
                                              <span class="form-control form-control-plaintext">
                                                  <strong>{{ totalQuantity }}</strong>
                                              </span>
                                          </td>
                                          <td></td>
                                          <td class="text-right">
                                              <span class="form-control form-control-plaintext">
                                                  <strong>{{ totalValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong>
                                              </span>
                                          </td>
                                          <td colspan="2"></td>
                                      </tr>
                                  </tbody>
                                  <tfoot v-if="isDisable">
                                      <tr>
                                          <td colspan="7">
                                              <button type="button" class="btn btn-sm btn-brand" @click.prevent="onAddItemClick">
                                                  <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                                              </button>
                                          </td>
                                      </tr>
                                  </tfoot>
                              </table>
                          </div>
                      </div>

                  </div>

                  <!-- Pitures -->
                  <div class="form-group"></div>
                  <div class="row">
                      <div class="col-xl-2 col-md-2 col-sm-2">
                          <label class="label">
                              <strong v-if="pictures.length && pictures[0].downloadUrl">รูปภาพอุปกรณ์ :</strong>
                              <strong v-else>รูปภาพอุปกรณ์ : ไม่มีภาพถ่าย</strong>
                          </label>
                          <div v-if="pictures.length && pictures[0].downloadUrl">
                              <div class="position-relative">
                                  <div class="p-1 d-flex flex-column justify-content-center align-items-center border-dashed">
                                      <img v-if="pictures[0]" :src="pictures[0].downloadUrl" @click="showModal(pictures[0].downloadUrl)" style="object-fit: contain; width: 100%; height: 100%;">
                                  </div>
                              </div>
                          </div>


                          <div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                              <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                                  <div class="modal-content mr-4">
                                      <div class="modal-header">
                                          <h5 class="modal-title">ภาพถ่าย</h5>
                                          <button type="button" class="close" aria-label="Close" @click="closeModal">
                                              <span aria-hidden="true">&times;</span>
                                          </button>
                                      </div>
                                      <div class="modal-body">
                                          <img :src="modalImageURL" style="max-width: 90%; max-height: 90%; margin: 0 auto; display: block;">
                                          <button type="button" class="close" aria-label="Close" @click="closeModal">
                                              <h6 class="modal-title"><i class="la la-close"></i> ปิดหน้าต่าง</h6>
                                          </button>
                                      </div>
                                  </div>
                              </div>
                          </div>

                      </div>
                  </div>

              </div>



          </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">
          <i class="la la-save"></i> {{ qiStatusCode == "JOB_QI_STATUS_SUCCESS" ? 'บันทึกข้อมูล' : 'ยืนยันข้อมูล' }}
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;
    return {
      qiJobId: null,
      qiJobNumber: null,
      qiStatusCode: null,
      qiTypeCode: '',
      qiSubType: 0,
      qiStatusName: null,
      qiAreaPlant: true,
      createdDate: null,
      createdUserName: null,
      finishedDate: null,
      confirmedDate: null,
      confirmedUserName: null,
      qiTypeName: null,
      amount: null,
      items: [],
      originalOptions: [],
      materialCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
      },
      errors: [],
      isDisable: true,
      pictures: [],
      modalImageURL: '',
      isFromImageModal: false,
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    try {
      await self.loadMaterialOptions();

      let response = await axios.get("/Api/QIJobs/" + this.$route.params.id);
      if (response.status === 200 && response.data) {
        self.qiJobId = response.data.qiJobId;
        self.qiJobNumber = response.data.qiJobNumber ? `เลขที่ใบงาน : ${response.data.qiJobNumber}` : '';
        self.qiTypeCode = response.data.qiTypeCode;
        self.qiSubType = response.data.qiSubType;

        let qiStatusCode = response.data.qiStatusCode;
        let statusIcon = '';
        let statusText = self.qiStatusName = response.data.qiStatusName;
        if (qiStatusCode === "JOB_QI_STATUS_PENDING") {
          statusIcon = '<i class="fa fa-sync-alt"></i>';
        } else if (qiStatusCode === "JOB_QI_STATUS_REQUEST_APPROVAL") {
          statusIcon = '<i class="fa fa-file-signature"></i>';
        } else if (qiStatusCode === "JOB_QI_STATUS_REPAIR_COMPLETED") {
          statusIcon = '<i class="fa fa-check"></i>';
        } else if (qiStatusCode === "JOB_QI_STATUS_CANCEL") {
          statusIcon = '<i class="fa fa-ban text-danger"></i>';
        } else if (qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
          statusIcon = '<i class="fa fa-check-circle"></i>';
          self.isDisable = false;
        }
        self.qiStatusCode = qiStatusCode;
        self.qiStatusName = statusIcon + ' ' + statusText;
        self.qiAreaPlant = response.data.qiAreaPlant;

        self.createdDate = response.data.createdDateFormat || '-';
        self.createdUserName = response.data.createdUserName || '-';
        self.finishedDate = response.data.finishedDate ? self.setDateFormat(response.data.finishedDate, true) : '-';
        self.confirmedDate = response.data.confirmedDate ? self.setDateFormat(response.data.confirmedDate, true) : '-';
        self.confirmedUserName = response.data.confirmedUserName || '-';

        let additionalText = '';
        if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK" && response.data.finishedDate) {
          additionalText = response.data.qiSubType === 1 ? ' <span>(เบิก)</span>' : ' <span>(คืน)</span>';
        }
        self.qiTypeName = response.data.qiTypeName ? response.data.qiTypeName + additionalText : '-';
        self.amount = response.data.amount || '-';

        if (response.data.items && Array.isArray(response.data.items)) {
          if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK") {
            self.amount = response.data.items.reduce((total, item) => total + item.quantity, 0);
          }
          self.items = response.data.items;
          }

          //response.data.picture.forEach((element) => {
          //    self.pictures.push({
          //        fileInfoId: element.fileInfoId,
          //        downloadUrl: element.downloadUrl
          //    });
          //});
          //=== set pictures ===
          if (response.data.picture && typeof response.data.picture !== 'undefined' && response.data.picture.length > 0) {
              async function loadPictures() {
                  response.data.picture.map(async (element) => {
                      self.pictures.push({
                          fileInfoId: element.fileInfoId,
                          downloadUrl: element.downloadUrl
                      });
                  });
              }
              loadPictures();
          }

        self.$nextTick(() => self.updateSelect2Options());

      } else {
          throw new Error("ไม่พบข้อมูลใบงานช่างซ่อมคุณเลือก");
      }

    } catch (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.message || "ระบบเกิดข้อผิดพลาด", "error");
        router.go(-1);
    } finally {
        KTApp.unblockPage();
    }
   },

   methods: {
    showModal(imageURL) {
        this.modalImageURL = imageURL;
        this.isFromImageModal = true;
        $('#imageModal').modal('show');
        $('#imageModal').on('hidden.bs.modal', () => {
            $('body').addClass('modal-open');
        });
    },
    closeModal() {
        $('#imageModal').modal('hide');
    },
    onAddItemClick(e) {
      if (!this.validateItems()) {
        return false;
      }
      this.items.push({
        qiJobItemId: Date.now(),
        materialCode: "",
        quantity: 0,
        unitPrice: 0,
        remark: "",
      });
      this.$nextTick(() => this.updateSelect2Options());
    },
    onRemoveItemClick(index) {
      this.items.splice(index, 1);
      this.$nextTick(() => this.updateSelect2Options());
    },
    onMaterialCodeChange(index) {
      const materialCode = this.items[index].materialCode;
      if (!materialCode) {
        return;
      }
      this.$nextTick(() => {
        const selectedItem = this.originalOptions.find(item => item.id === materialCode);
        if (selectedItem) {
          this.$set(this.items[index], 'unitPrice', selectedItem.data.qiPrice);
        }
      });
    },
    async loadMaterialOptions() {
      try {
        let response = await axios.post("/Api/QIJobs/ProductOption", {
          page: 0,
          limit: 1000,
          optionWithCode: true,
          qiTypes: ['QiSpare']
        });

        if (response.status === 200) {
          this.originalOptions = response.data.results.map(element => ({
            id: element.id,
            text: element.text,
            data: element.data
          }));

          this.updateSelect2Options();
        }
      } catch (error) {
        console.error('Error loading material options:', error);
      }
    },
    getMaterialCodeOptions(index) {
      const selectedCodes = this.items.map((item, idx) => idx !== index ? item.materialCode : null).filter(code => code);
      const availableOptions = this.originalOptions.filter(option => !selectedCodes.includes(option.id));
      return {
        data: availableOptions,
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true
      };
    },
    async updateSelect2Options() {
      const usedOptions = this.items.map(item => item.materialCode);
      this.materialCodeOptions.data = this.originalOptions.filter(option => !usedOptions.includes(option.id));

      this.$nextTick(() => {
        this.items.forEach((item, i) => {
          const selectRef = this.$refs[`materialSelect2-${i}`];
          if (selectRef && selectRef.$el) {
            $(selectRef.$el).select2('destroy').select2(this.materialCodeOptions);
          }
        });
      });
    },
    setDateFormat(dateStr, includeTime = false) {
      let options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        calendar: 'gregory'
      };
      if (includeTime) {
        options = {
          ...options,
          hour: '2-digit',
          minute: '2-digit'
        };
      }
      let dateStrFormat = new Date(dateStr).toLocaleDateString('th-TH', options);
      return dateStrFormat;
    },
    validateItems() {
      let isValid = true;
      this.errors = []; // รีเซ็ตข้อผิดพลาด
      this.items.forEach((item, index) => {
        const materialSelect2Ref = this.$refs[`materialSelect2-${index}`];
        if (materialSelect2Ref && materialSelect2Ref.length) {
          const select2Element = materialSelect2Ref[0];
          if (!select2Element.value) {
            isValid = false;
            this.$set(this.errors, index, { ...this.errors[index], materialCode: 'กรุณาเลือกสินค้า' });
          } else {
            this.$set(this.errors, index, { ...this.errors[index], materialCode: '' });
          }
        }

        const quantityInputRef = this.$refs[`quantity-${index}`];
        if (quantityInputRef && quantityInputRef.length) {
          const quantityElement = quantityInputRef[0];
          if ($(quantityElement).val() == '') {
            isValid = false;
            this.$set(this.errors, index, { ...this.errors[index], quantity: 'กรุณากรอกจำนวน' });
          } else {
            this.$set(this.errors, index, { ...this.errors[index], quantity: '' });
          }
        }

        const unitPriceInputRef = this.$refs[`unitPrice-${index}`];
        if (unitPriceInputRef && unitPriceInputRef.length) {
          const quantityElement = unitPriceInputRef[0];
          if ($(quantityElement).val() == '') {
            isValid = false;
            this.$set(this.errors, index, { ...this.errors[index], unitPrice: 'กรุณากรอกราคา/หน่วย' });
          } else {
            this.$set(this.errors, index, { ...this.errors[index], unitPrice: '' });
          }
        }
      });
      return isValid;
    },
    formSubmit: function(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (!this.validateItems()) {
        return false;
      }

      if (this.items.length == 0) {
        Swal.fire(
          "",
          "กรุณาเพิ่มรายการอุปกรณ์",
          "warning"
        );
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/EditDrawback",
        data: {
          QIJobId: this.qiJobId,
          QIJobItems: this.items,
        },
      })
      .then(function(response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(
            function() {
              router.go(-1), self.$parent.reloadDataTable(false);
            }
          );
        } else {
          Swal.fire({
            title: "ไม่สามารถบันทึกข้อมูลได้",
            type: "error",
            html: response.data.message.replace(/\n/g, "<br>"),
          });
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    },
  },
  computed: {
    totalQuantity() {
      return this.items.reduce((sum, item) => sum + (item.quantity || 0), 0);
    },
    totalValue() {
      return this.items.reduce((sum, item) => sum + (item.quantity * item.unitPrice || 0), 0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// App/Components/QIJob/QIJobEditDrawback.vue